import React, { useCallback, useEffect, useRef, useState } from "react"
import { HexColorPicker } from "react-colorful"

import classes from "./ColorPickerInput.module.scss"

const ColorPickerInput = (props) => {
  const { color, onChange } = props

  const [showColorDropdown, setShowColorDropdown] = useState(false)

  const ref = useRef(null)

  const handleClick = () => {
    setShowColorDropdown(prev => !prev)
  }

  const handleClickOutside =
    useCallback((e) => {
      if (!ref.current || ref.current.contains(e.target)) return

      setShowColorDropdown(false)
    }, [])

  useEffect(() => {
    window.addEventListener("click", handleClickOutside)

    return () => {
      window.removeEventListener("click", handleClickOutside)
    }
  }, [])

  return (
    <div
      ref={ref}
      className={classes["color-input-container"]}
    >
      <div
        onClick={handleClick}
        className={classes["color-input"]}
      >
        <div
          style={{ backgroundColor: color }}
          className={classes["color-bar"]}
        />
      </div>
      {
        showColorDropdown &&
        <div className={classes["color-dropdown"]}>
          <HexColorPicker
            color={color}
            onChange={onChange}
          />
        </div>
      }
    </div>
  )
}

export default ColorPickerInput
